/*
|----------------------------------------------------------------------------
| Shared skeleton animation clock
|----------------------------------------------------------------------------
|
| CSS animations normally start when each element mounts. In Desktop Focus,
| the ticker skeleton and card skeleton can mount a few frames apart, which
| makes otherwise identical pulse and shimmer effects look out of sync.
|
| These delays align every skeleton to the same browser clock. A component
| mounted later starts from the phase that the earlier component has already
| reached instead of restarting from zero.
|
*/
export const SKELETON_PULSE_DURATION_MS = 2400;
export const SKELETON_SHIMMER_DURATION_MS = 1650;

const getAnimationClockMs = () => {
  if (
    typeof performance !== "undefined" &&
    typeof performance.now === "function"
  ) {
    return performance.now();
  }

  return Date.now();
};

export const createSynchronizedSkeletonStyle = () => {
  const now = getAnimationClockMs();

  return {
    "--skeleton-pulse-delay": `${-(
      now % SKELETON_PULSE_DURATION_MS
    )}ms`,
    "--skeleton-shimmer-delay": `${-(
      now % SKELETON_SHIMMER_DURATION_MS
    )}ms`,
  };
};
